import { AccordionSummary } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const StyledAccordionSummary = withStyles({
  root: {
    display: 'flex',
    flexDirection: 'row-reverse',
    '&.Mui-disabled': {
      opacity: '1',
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
  expandIcon: {
    padding: 'none',
    marginRight: '8px',
  },
})(AccordionSummary);
